<div class="ui grid">
  <div *ngIf="totalDto" style="margin-top: 30px;" class="centered column two ui wide">
    <div class="ui centered grid">
      <div class="ui statistic">
        <div class="value">{{totalDto?.total1}}</div>
        <div class="label">Checkins</div>
      </div>

      <div class="ui statistic">
        <div class="value">{{totalDto?.total2}}</div>
        <div class="label">Nights</div>
      </div>
    </div>
  </div>
  <div class="fourteen wide column">
    <chart style="height: 600px;"
           [type]="chartData.type"
           [datasets]="chartData.data.datasets"
           [labels]="chartData.data.labels"
           [options]="chartData.options">
    </chart>
  </div>
</div>
